import { baseUrl, AppId } from "../config/app.config";
import axios from "axios";

export const authenticateUser = async email => {
  let result = { error: false, data: "" };

  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/Login/authenticate",
      data: {
        Email: email,
        AppId: AppId
      }
    });

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = "An error occured while processing your request";
  }

  return result;
};

export const reAuthenticateUser = async refreshToken => {
  let result = { error: false, data: "" };

  try {
    var response = await axios(baseUrl + "/api/Login/reauthenticate", {
      headers: { Authorization: `Bearer ${refreshToken}` }
    });

    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = "An error occured while processing your request";
  }

  return result;
};
